import Parse from "../../api/ApiConfig";

/**********************
	API functions
**********************/
const requestHeaders = {
	"X-Parse-Application-Id": "FortCore",
};

export const fetchChartData = async (type) => {
	try {
		const url = process.env.REACT_APP_SERVER_URL + `/functions/${type}`;
		// Fetch data from server
		const response = await fetch(url, {
			method: "POST",
			headers: requestHeaders,
		});

		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

// Fetch Logistics table data
export const fetchTableData = async (category, filter) => {
	try {
		if (category) {
			let url = process.env.REACT_APP_SERVER_URL + "/functions/";
			// update url based on category
			switch (category) {
				case "awaiting_purchase":
					url += "getAwaitingAssets";
					break;
				case "awaiting_procurement":
					url += "getAwaitingProcuredAssets";
					break;
				case "procured_assets":
					url += "getPurchasedAssets";
					break;
				case "deployed_assets":
					url += "getDeployedAssets";
					break;
				case "maintained_assets":
					url += "getMaintainedAssets";
					break;
				case "inspected_assets":
					url += "getInspectedAssets";
					break;
				case "retained_assets":
					url += "getRetainedAssets";
					break;
				case "repaired_assets":
					url += "getRepairedAssets";
					break;
				case "retrieved_assets":
					url += "getRetrievedAssets";
					break;
				case "reassigned_assets":
					url += "getReassignedAssets";
					break;
				case "sold_assets":
					url += "getSoldAssets";
					break;
				default:
					return [];
			}

			const response = await fetch(url, {
				method: "POST",
				headers: requestHeaders,
				body: JSON.stringify({ queryType: filter }),
			});
			const data = await response.json();
			console.log(category, filter, data.result);
			const newData = data.result?.sort(
				(leaseOne, leaseTwo) =>
					new Date(leaseTwo?.createdAt)?.getTime() - new Date(leaseOne?.createdAt)?.getTime()
			);

			return data ? newData : [];
		} else return null;
	} catch (error) {
		console.log(error);
		return null;
	}
};

// Fetch single Logistics object
export const fetchLogObject = async (objectId, filter) => {
	try {
		if (objectId) {
			const url = process.env.REACT_APP_SERVER_URL + "/functions/viewLogisticsById";
			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify({ id: objectId, queryType: filter }),
				headers: requestHeaders,
			});
			const data = await response.json();
			return !data.error ? data : { error: data.error };
		} else {
			return { error: "Logistic Object ID not specified" };
		}
	} catch (error) {
		console.log(error);
		return null;
	}
};

// Update Logistics Object
export const updateLogObject = async (objectId, data, filter) => {
	console.log(objectId, data, filter);
	if (objectId && data) {
		let ParseObj;
		switch (filter) {
			case "lease":
				ParseObj = Parse.Object.extend("Lease");
				break;
			case "AFinance":
				ParseObj = Parse.Object.extend("ApprenticeshipFinance");
				break;
			default:
				return { error: "Invalid filter" };
		}
		let parseObject = new ParseObj();
		parseObject.id = objectId;
		// Save data
		parseObject = await parseObject.save(data);
		return parseObject;
	} else {
		return { error: "Object ID or data not specified" };
	}
};

export const formatDeliveryType = (deliveryType) => {
	const splitData = deliveryType?.split("-");
	const modifyData = splitData?.map((a) => {
		const upC = a?.charAt(0)?.toUpperCase();
		return `${upC}${a?.slice(1)}`;
	});
	return modifyData?.join(" ");
};

export const onUpdateAsset = async (assetId, data) => {
	try {
		const queryOne = new Parse.Query("Asset");
		const objectOne = await queryOne.get(assetId);
		const updatedObjectOne = await objectOne.save(data);

		return updatedObjectOne;
	} catch (error) {
		console.log(error);
	}
};

export const onUpdateInvestorFinance = async (financeId, data) => {
	try {
		const queryOne = new Parse.Query("AFBusinessCreate");
		const objectOne = await queryOne.get(financeId);
		const updatedObjectOne = await objectOne.save(data);

		return updatedObjectOne;
	} catch (error) {
		console.log(error);
	}
};

export const getAssetRegPaymentStatus = (leaseData) => {
	const regInfo = leaseData?.assetRegistration;

	const totalAmount = regInfo ? regInfo[0]?.totalAmount : 0;

	const totalAmountPaid = regInfo?.reduce((acc, cur) => acc + cur?.amountToPay || cur?.amountPaid, 0);

	const paymentStatus =
		regInfo && totalAmountPaid === totalAmount
			? "Completed"
			: regInfo?.length && totalAmountPaid !== totalAmount
			? "Incomplete"
			: "---";

	const isPaymentComplete = totalAmountPaid === totalAmount;

	return { paymentStatus, isPaymentComplete };
};

export const getInsurancePaymentStatus = (leaseData) => {
	const regInfo = leaseData?.insurancePaymentInfo;

	const totalAmount = regInfo ? regInfo?.totalAmount : 0;

	const totalAmountPaid = regInfo?.investors?.reduce(
		(acc, cur) => acc + (cur?.amountToPay || cur?.amountPaid),
		0
	);

	const paymentStatus =
		regInfo && totalAmountPaid === totalAmount
			? "Completed"
			: regInfo?.investors?.length && totalAmountPaid !== totalAmount
			? "Incomplete"
			: "---";

	const isPaymentComplete = totalAmountPaid === totalAmount;

	return { paymentStatus, isPaymentComplete };
};
